<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>
    <template v-if="!loading">

      <div class="text-right">
        <button @click="() => editPhone()" type="button" class="btn btn-outline-success btn-xs">Добавить новый номер
          телефона
        </button>
      </div>

      <table class="table table-hover table-sm mt-1">
        <thead>
        <tr>
          <th></th>
          <th>Телефон</th>
          <th>Слот</th>
          <th>Оператор</th>
          <th>Карты</th>
          <th>Доступ</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(p, i) in localPhones" :key="p.id">
          <td>{{ i + 1 }}</td>
          <td>({{ p.id }}) {{ p.phone_number }}</td>
          <td>{{ p.slot }}</td>
          <td>{{ p.operator }}</td>
          <td>
            <p v-for="card in p.cards">({{ card.id }}) {{ card.number }} ({{ card.owner && card.owner.short_name }})</p>
          </td>
          <td>
            <button v-if="!showAccess[p.id]" @click="showAccess[p.id] = true" class="btn btn-default btn-xs">показать
            </button>
            <template v-if="showAccess[p.id] && p.extra">
              {{ p.extra.login }}:{{ p.extra.pass }}
            </template>
          </td>
          <td>
            <button
              @click="editPhone(p)"
              class="btn btn-outline-info btn-xs"
            >
              <i class="icon-fa icon-fa-edit"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['phones', 'updatePhones'],
  data() {
    return {
      loading: false,
      showAccess: {},
      localPhones: []
    }
  },
  created() {
    if (!this.phones.length) {
      this.getPhones();
    }
  },
  methods: {
    editPhone(phone = null) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {type: 'editServicePhone', phone: phone},
        callBackAction: (p) => this.updatePhoneRecord(phone.id, p)
      });
    },
    updatePhoneRecord(id, p) {
      // console.log('update phone', id, p)
      const index = this.localPhones.findIndex((phone) => phone.id === id);
      // console.log(index);
      if (index !== -1) {
        this.localPhones[index] = {...this.localPhones[index], ...p};
        this.localPhones = [...this.localPhones];
      }
    },
    async getPhones() {
      this.loading = true;
      const {data} = await api.index('/cards/phones');
      if (data.success) {
        this.localPhones = data.records;
        if (this.updatePhones) {
          this.updatePhones(data.records);
        }
        this.showAccess = data.records.reduce((acc, p) => {
          acc[p.id] = false;
          return acc;
        }, {})
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    }
  }
}

</script>
